import { Modal } from '../models';

export class ClosedModalError extends Error {
    constructor(public modal: Modal) {
        super('Modal was closed');
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ClosedModalError.prototype);
    }
}
